import React from 'react';
import { Tabs } from '@applyboard/crystal-ui';

type ApplicationDetailsTabsProps = {
  submittedApplicationDetails: React.ReactNode;
  applicationDetails: React.ReactNode;
  evaluationDetails: React.ReactNode;
  showEvaluationTab?: boolean;
};

export function ApplicationDetailsTabs(props: ApplicationDetailsTabsProps) {
  const { submittedApplicationDetails, applicationDetails, evaluationDetails, showEvaluationTab = true } = props;
  const [activeTab, setActiveTab] = React.useState('1');
  return (
    <Tabs align="left" onChange={setActiveTab} value={activeTab} orientation="horizontal">
      <Tabs.Item label="Submitted" value="1">
        {submittedApplicationDetails}
      </Tabs.Item>
      <Tabs.Item label="Details" value="2">
        {applicationDetails}
      </Tabs.Item>
      {showEvaluationTab && (
        <Tabs.Item label="Evaluation" value="3">
          {evaluationDetails}
        </Tabs.Item>
      )}
    </Tabs>
  );
}
